/**
 * Stable CSS class names for E2E — No order shot search.
 */
export const NOSS = {
    page: 'no-order-shot-search-page',
    breadcrumbSection: 'no-order-shot-search-page__breadcrumb-section',
    loadingSection: 'no-order-shot-search-page__loading-section',
    mainLayout: 'no-order-shot-search-page__main-layout',
    inputColumn: 'no-order-shot-search-page__input-column',
    inputTextOrderNumbers: 'no-order-shot-search-page-input--text-order-numbers',
    actionsRow: 'no-order-shot-search-page__actions-row',
    clearButtonWrap: 'no-order-shot-search-page__clear-button-wrap',
    inputButtonClear: 'no-order-shot-search-page-input--button-clear',
    searchButtonWrap: 'no-order-shot-search-page__search-button-wrap',
    inputButtonSearch: 'no-order-shot-search-page-input--button-search',
    resultsColumn: 'no-order-shot-search-page__results-column',
    resultsCard: 'no-order-shot-search-page__results-card',
    resultsTitleRow: 'no-order-shot-search-page__results-title-row',
    copyResultsButtonWrap: 'no-order-shot-search-page__copy-results-button-wrap',
    resultsListWrap: 'no-order-shot-search-page__results-list-wrap',
    resultsList: 'no-order-shot-search-page__results-list',
    resultsListItem: 'no-order-shot-search-page__results-list-item',
} as const;

export const nossCls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');
